import { getGoalSiteAri } from '@atlassian/projects-goals-common/get-app-site-ari';
import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';

import SavedTabsAggRootQueryNode, {
	type SavedTabsAggRootQuery,
} from '../StatusUpdatesNavigation/agg/__generated__/SavedTabsAggRootQuery.graphql';

export const statusUpdatesNavigationAggResource: RouteResource<
	PreloadedQuery<SavedTabsAggRootQuery, Record<string, unknown>>
> = createRelayResource<SavedTabsAggRootQuery>({
	getQuery: (routerContext, resourceContext) => {
		const context = resourceContext as ResourceContext;
		const viewId = routerContext.match.params.uuid;

		return {
			query: SavedTabsAggRootQueryNode,
			variables: {
				containerId: getGoalSiteAri(context.collabContext?.contextId ?? ''),
				viewId: viewId ?? '',
				shouldFetchSavedView: Boolean(viewId),
			},
			options: {
				fetchPolicy: 'store-and-network',
			},
			environment: getAggRelayEnvironment(),
		};
	},
});
